import { render, staticRenderFns } from "./OrderDraftList.vue?vue&type=template&id=01e7bdeb&scoped=true&"
import script from "./OrderDraftList.vue?vue&type=script&lang=js&"
export * from "./OrderDraftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7bdeb",
  null
  
)

export default component.exports